// possible values for side menu position.
export enum SideMenuPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

// possible values for side menu width
export enum SideMenuWidthValues {
  SMALL = '300',
  MEDIUM = '400',
  WIDE = '560',
}

export enum SideMenuEvents {
  OPEN = 'open',
  CLOSE = 'close',
}
